<template>
  <Popup :ref="(el) => popup = el"
         :hide-title="true"
         @onClose="hide"
  >
    <div class="popup__content payout-rules">
      <img :src="require('@/apps/public/assets/img/payout-rules.png')" class="payout-rules__img" alt="">
    </div>
    <div class="popup__controls">
      <button type="button" @click="hide" class="btn popup__close">
        <span class="text-capitalize-first">{{ helper.trans('button.cancel') }}</span>
      </button>
      <LoaderButton :on-click="onAcceptClick" class="btn btn--accept">
        <span class="text-capitalize-first">{{ helper.trans('button.i_accept') }}</span>
      </LoaderButton>
    </div>
  </Popup>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {useStore} from "vuex";
import Popup from "@/apps/public/components/Popup.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {helper} from "@/service/CommonHelper";
import {Direction} from "@/models/enum/Direction";

export default defineComponent({
  components: {LoaderButton, Popup},
  setup() {
    const store = useStore()
    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const show = () => {
      popup.value?.show()
    }

    const hide = () => {
      popup.value?.hide()
    }

    const onAcceptClick = async () => {
      await store.dispatch('toggleTraderStatus', {
        isActive: true,
        direction: Direction.PAY_OUT
      })
      hide()
    }

    return {
      popup,
      helper,
      show,
      hide,
      onAcceptClick,
    }
  }
})
</script>
<style scoped>
.payout-rules {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.payout-rules__img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
